import merge from 'lodash/merge'
import { IBaseInputLikeStyledTheme, IInputLikeStyledTheme } from 'merchants/types/IThemeStyles';
import { baseTheme } from 'merchants/identance';
import { palette } from './palette';

const defaultGlobalBaseInputLikeStyles: IBaseInputLikeStyledTheme = {
  backgroundColor: palette.c13,
  borderColor: palette.c8,
  fontSize: '15px',

  disabled: {
    borderColor: palette.c8,
    backgroundColor: 'transparent',
  },

  valid: {
    borderColor: palette.c6
  }
};

const defaultGlobalInputLikeStyles: IInputLikeStyledTheme = {
  ...defaultGlobalBaseInputLikeStyles,

  borderRadius: '4px',
  borderWidth: '1px',
  color: palette.c1,
  boxShadow: 'none',

  focus: {
    backgroundColor: palette.c3,
    borderColor: palette.c4,
  },

  disabled: {
    ...defaultGlobalBaseInputLikeStyles.disabled,
    color: palette.c7,
  },

  error: {
    backgroundColor: palette.c3,
    borderColor: palette.c5,
  },
};

export const theme = {
  layout: {
    backgroundColor: palette.c12
  },
  buttons: {
    base: {
      borderRadius: '4px',
      backgroundColor: palette.c3,
      border: `1.5px solid ${palette.c4}`,
      color: palette.c4,
      hover: {
        color: palette.c3,
        backgroundColor: palette.c4,
      }
    },
    primary: {
      backgroundColor: palette.c4,
      borderRadius: '4px',
      border: `1.5px solid ${palette.c4}`,

      hover: {
        backgroundColor: palette.c3,
        color: palette.c4,
      }
    },
    resubmit: {
      triggerColor: palette.c3
    }
  },
  links: {
    base: {
      color: palette.c4,
      hover: {
        color: palette.c4,
      },
    },
    exit: {
      backgroundColor: palette.c3,
      color: palette.c4,
      hover: {
        color: palette.c3,
        backgroundColor: palette.c4,
      }
    },
    nav: {
      borderRadius: '4px',
      borderColor: palette.c4,
      borderWidth: '1.5px',
      backgroundColor: palette.c4,
      hover: {
        backgroundColor: palette.c3,
        color: palette.c4
      }
    },
  },
  forms: {
    dropdown: {
      ...defaultGlobalInputLikeStyles,
      placeholderColor: palette.c7,
    },
    input: {
      ...defaultGlobalInputLikeStyles
    },
    radio: {
      ...defaultGlobalBaseInputLikeStyles,
      borderWidth: '1px',

      checked: {
        backgroundColor: palette.c13,
        borderColor: palette.c6,
        backgroundColorAfter: palette.c4,
      },
    },
    textarea: {
      ...defaultGlobalInputLikeStyles
    },
    tumbler: {
      boxShadow: '0 1px 8px 0 #e5e5e5',
      borderWidth: '1px',
      borderColor: palette.c1,
      backgroundColor: palette.c1,

      checked: {
        borderColor: palette.c4,
        backgroundColor:palette.c4,

      }
    }
  },
  text: {
    badge: {
      primary: {
        backgroundColor: palette.c18,
      },
    },
    error: {
      paddingTop: '2px',
      paddingLeft: '0px'
    },
    h1: {
      color: palette.c1,
    },
    h3: {
      color: palette.c1,
    },
    h4: {
      color: palette.c1,
    },
  },
  components: {
    appendControl: {
      color: palette.c6
    },
    breadcrumbs: {
      color: palette.c2,
      darkArrow: true
    },
    divider: {
      backgroundColor: palette.c12,
    },
    feedback: {
      textColor: palette.c1
    },
    modal: {
      colorCloseButton: palette.c3,
      backgroundColorCloseButton: palette.c10,
    },
    modalPreview: {
      colorCloseButton: palette.c3,
      backgroundColorCloseButton: palette.c15,
    },
    navigation: {
      backgroundColor: palette.c3,
      boxShadow: '0 2px 17px 0 #e5e5e5'
    },
    previewArea: {
      borderRadius: '8px',
    },
    progress: {
      backgroundColor: palette.c9,
      backgroundColorAfter: palette.c4,
      tagColor: palette.c1,
      tagFontWeight: 'normal'
    },
    slider: {
      backgroundColorActive: palette.c7,
      backgroundColor: palette.c14,
    },
    stagePreview: {
      borderRadius: '8px'
    },
    statusBox: {
      background: {
        primary: palette.c18,
      },
    },
    uploader: {
      borderColorLabel: palette.c10,
      borderRadius: '8px',
      borderRadiusLabel: '12px',
      error: {
        borderColor: palette.c5,
      },
    },
  },
  icons: {
    markup: {
      exit: {
        fill: palette.c4
      },
      star: {
        def: palette.c8,
        active: palette.c4
      },
    },
    docs: {
      backSide: {
        fill: palette.c8,
        fill2: palette.c16
      },
      blankStatement: {
        fill: palette.c8
      },
      doc: {
        fill: palette.c8
      },
      electricityBill: {
        fill: palette.c8
      },
      frontSide: {
        fill: palette.c16,
        fill2: palette.c8,
        fill3: palette.c12
      },
      miningActivity: {
        fill: palette.c8
      },
      selfie: {
        fill: palette.c8,
        fill2: palette.c16
      },
      selfieWithNote: {
        fill: palette.c8,
        fill2: palette.c16
      },
      taxes: {
        fill: palette.c8,
        fill2: palette.c20
      },
      tradingActivity: {
        fill: palette.c8
      },
      utilityBill: {
        fill: palette.c8,
        fill2: palette.c10,
        fill3: palette.c20
      },
    },
  }
};

export const themeCex = merge({}, baseTheme, theme);
